import React from 'react';

import { FormField } from 'fr-shared/components';

const BuildDensityFormField = props => {
  return <FormField name="build_density" label="Build Density" append="%" {...props} />;
};

export default BuildDensityFormField;
